export default __webpack_public_path__ + "static/media/ulm_dark.d3153267.png";